import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface AuthState {
  offerData: any;
}

const initialState: AuthState = {
  offerData: null,
};

export const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {
    setOfferData: (
      state,
      action: PayloadAction<Pick<AuthState, "offerData">>
    ) => {
      state.offerData = action.payload.offerData;
    },
  },
});
export const { setOfferData } = offerSlice.actions;
export const getOfferData = (state: RootState) => state.offer.offerData;
export default offerSlice.reducer;
